import React from "react";
import {Row} from "react-bootstrap";
import {Col} from "react-bootstrap";
import useQueryJobAlertsSearch from "../search/useQueryJobAlertsSearch.js";
import WaitForData from "../../common/data-fetching/WaitForData.js";
import DashboardAlertsListItems from "./JobDashboardAlertsListItems.js";
import Loader from "../../common/loading-widgets/Loader.js";
import useShowLoader from "../../common/loading-widgets/useShowLoader.js";
import useTranslationJobDashboard from "../useTranslationJobDashboard.js";
import "./JobDashboardAlertsBlock.scss";

export default function JobDashboardAlertsBlock(props) {
  const { job } = props;
  const ALERTS_LIST_LENGTH = 10;
  const ALERTS_LIST_STATUS = "NOT_VIEWED";
  const ALERTS_LIST_SORT_TYPE = "DATE_ASC";

  const { t, loading: tLoading } = useTranslationJobDashboard();
  useShowLoader(tLoading, "JobDashboardAlertsBlock");

  const { data, loading, errors } = useQueryJobAlertsSearch(
    ALERTS_LIST_LENGTH,
    { jobId: job._id, status: ALERTS_LIST_STATUS },
    ALERTS_LIST_SORT_TYPE
  );

  const blockTitle = t("job-dashboard:job_dashboard_alerts_list_label");

  return (
    <>
      <Loader>
        <WaitForData
          loading={loading}
          errors={errors}
          onLoaded={() => (
            data["nodes"].length > 0 && (
              <div className="DashboardAlertsList widget-block">
                <Row>
                  <Col className={"title-col"}>
                    <h2>{blockTitle}</h2>
                  </Col>
                </Row>
                <DashboardAlertsListItems items={data["nodes"]} />
              </div>
            )
          )}
        />
      </Loader>
    </>
  );
}
